import { memo } from 'react';
const SvgMaximize2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="maximize-2_svg__feather maximize-2_svg__feather-maximize-2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
  </svg>
);
const Memo = memo(SvgMaximize2);
export default Memo;
